import { searchLineStyles } from '../../api/line-styles.api';
import { SearchLineStylesApiRequest } from '../../../../types/requests/line-styles/search-line-styles.request';
import { useAxiosInfiniteQuery } from './use-axios.hook';

const baseQueryKey = 'line-style';
const searchQueryKey = 'search';

export const useSearchLineStyles = (params: SearchLineStylesApiRequest) => {
  const { data, ...result } = useAxiosInfiniteQuery({
    queryKey: [baseQueryKey, searchQueryKey, params],
    queryFn: async ({ pageParam }) => (await searchLineStyles({ cursor: pageParam, ...params })).data,
    initialPageParam: params.cursor,
    getNextPageParam: (lastResponse) => lastResponse.nextCursor,
  });
  return { ...result, response: data } as const;
};
